import React from 'react';

import { Button, ButtonCommonProps } from './Button';
import { LocalizedLink } from '../LocalizedLink';

export const ButtonLocalizedLink: React.FC<
  React.ComponentProps<typeof LocalizedLink> & ButtonCommonProps
> = props => <Button as={LocalizedLink} {...props} />;
